//
//
//
//
//
//
//
//
//
//
//
//

import SearchItemDropdown from '@/components/search/SearchItemDropdown'
import { taskLocations } from 'ct-constants'

export default {
  name: 'TaskLocationDropdown',
  components: { SearchItemDropdown },
  props: {
    selected: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /**
     * Array of locations
     * @returns {[]}
     */
    locations () {
      return [
        {
          id: taskLocations.ONSITE,
          name: this.$t('tasks.form.onsite')
        },
        {
          id: taskLocations.REMOTE,
          name: this.$t('tasks.form.remote')
        },
        {
          id: taskLocations.HYBRID,
          name: this.$t('tasks.form.hybrid')
        }
      ]
    },

    label () {
      return this.selected ? this.locations.find(c => c.id === this.selected).name : this.$t('tasks.form.location')
    }
  },
  methods: {
    select (c) {
      this.$emit('select', c.id)
    },

    remove () {
      this.$emit('select', null)
    }
  }
}
